// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

const isVersionResultItem = objectOf({
  id: string,
  version: number,
  created_at: number,
  changed_fields: arrayOf(string),
  is_current: boolean,
  created_by: maybe(string, true),
});

export const isGenerativeAiAgentIdVersionsResult = objectOf({
  hits: number,
  current_version: maybe(number, true),
  results: arrayOf(isVersionResultItem),
});
